var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMdiApprove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_124_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7428 6.68947L10.5228 5.29947L10.6928 3.45947L8.8878 3.04947L7.9428 1.45947L6.2428 2.18947L4.5428 1.45947L3.5978 3.04947L1.7928 3.45447L1.9628 5.29447L0.742798 6.68947L1.9628 8.07947L1.7928 9.92447L3.5978 10.3345L4.5428 11.9245L6.2428 11.1895L7.9428 11.9195L8.8878 10.3295L10.6928 9.91947L10.5228 8.07947L11.7428 6.68947ZM5.2428 9.18947L3.2428 7.18947L3.9478 6.48447L5.2428 7.77447L8.5378 4.47947L9.2428 5.18947L5.2428 9.18947Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_124_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.242798 0.689453)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiApprove);
export default __webpack_public_path__ + "static/media/mdi_approve.6eec8064d7a910ff10dbbcadb69655c9.svg";
export { ForwardRef as ReactComponent };